const claimformConstants = {
  SET_DATA: 'SET_DATA',
  SET_INITIATE: 'SET_INITIATE',
  SET_LANDLORD_ARRAY: 'SET_LANDLORD_ARRAY',
  SET_APARTMENT_ARRAY: 'SET_APARTMENT_ARRAY',
  SET_RIDER_ARRAY: 'SET_RIDER_ARRAY',
  CREAT_CLAIM: 'CREAT_CLAIM',
  SET_CLAIMID: 'SET_CLAIMID',
  SET_AGREEMENTID: 'SET_AGREEMENTID',
  SET_LEDGERID: 'SET_LEDGERID',
  SET_ERR: 'SET_ERR',
  GET_APARTMENT: 'GET_APARTMENT',
  GET_RIDER: 'GET_RIDER',
  GET_LANDLORD: 'GET_LANDLORD',
  CHECK_POLICY_DUPLICATED: 'CHECK_POLICY_DUPLICATED',
  SET_POLICY_DUPLICATED: 'SET_POLICY_DUPLICATED',
  SET_CLAIM_RESULT: 'SET_CLAIM_RESULT',
  SET_TENANTS: 'SET_TENANTS',
  SET_TENANTS_LOADING: 'SET_TENANTS_LOADING',
  SET_SELECTED_TENANT: 'SET_SELECTED_TENANT',
  SET_TENANT_ARRAY: 'SET_TENANT_ARRAY',
  GET_TENANTS: 'GET_TENANTS',
  LOOKUP_POLICY: 'LOOKUP_POLICY',
};

export default claimformConstants;
